import isMarineVehicleType from './isMarineVehicleType';

export default function isPowersportsCollateral(vehicleSelfSelectionStore, partnerStore) {
    const vssType = vehicleSelfSelectionStore?.type?.id;
    if (vssType) {
        return !isMarineVehicleType(vssType) && vssType !== 'automobile';
    }

    const rawCategory = (partnerStore?.rawVehicle?.product_category || '').toLowerCase();
    if (rawCategory) {
        return !['marine power boat', 'marine pontoon', 'automobile'].includes(rawCategory);
    }

    return !partnerStore?.isRV;
}
